import { isProduction } from '~/utils/env'

export const FEEDBACKS_NOTION_PAGE_URL = isProduction()
  ? 'https://www.notion.so/f48cfa66358c44478d3ef7b42a533c16?v=c58cd18e56e94c3096981bfc3021e585'
  : 'https://www.notion.so/e06b7fd6b4a448159226713e8660a39c?v=3db097af35ff44a59261a1a7dff396fc'
